import React, { useState } from "react";
// import ContractOverview from "../../../../components/cards/ContractOverview";
import VendorTable from "./VendorTable";
import ChatVendor from "./ChatVendor";

// const metrics = [
//   { title: "All Products", value: 30 },
//   { title: "Paid Contract", value: 2 },
//   { title: "Pending Contract", value: 1 },
//   { title: "Abandoned Contract", value: 1 },
// ];

const Vendor = () => {
  const [openChat, setOpenChat] = useState(false);

  return (
    <div className=" flex flex-col gap-6 md:p-8 p-4 bg-gray-100 min-h-screen">
      <div className="flex items-center justify-between">
        <h1 className=" text-lg md:text-2xl font-bold">User Management</h1>
        {/* <div>
          <button
            className="text-accent text-sm font-semibold pointer"
            onClick={() => setOpenChat(true)}
          >
            Chat with Vendor
          </button>
        </div> */}
      </div>
      {/* <ContractOverview
        contractId="INT-0000000001"
        shopName="Fanta design shop"
        status="Completed"
        metrics={metrics}
      /> */}
      <VendorTable />
      <ChatVendor isOpen={openChat} onClose={() => setOpenChat(false)} />
    </div>
  );
};

export default Vendor;
